import { Loader } from '@assets/icons'
import React from 'react'

interface IProps {
    type: 'button' | 'submit' | 'reset' | undefined
    children: React.ReactNode | React.ReactNode[]
    onClick: () => void
    title?: string
    isDisabled?: boolean
    isLoading?: boolean
}

export default function ButtonAction(props: IProps): React.ReactElement {
    return (
        <button title={props.title} disabled={props.isDisabled || props.isLoading} type={props.type} onClick={props.onClick} className={`button-action ${props.isDisabled ? 'disabled' : ''}`}>
            {props.isLoading ?
                <Loader style={{ width: '1rem' }} />
                :
                props.children
            }
        </button>
    )
}
